// import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'

import { Card, Icon } from 'semantic-ui-react'

const MinionKeys = (props) => {
  let { accepted, pending, refused } = props

  return (
    <Card>
      <Card.Content textAlign='center'>
        <Icon name='key' size={'huge'} />
      </Card.Content>
      <Card.Content textAlign='center'>
        <Card.Header><span style={{color: 'green'}}>{accepted}</span> / <span style={{color: 'orange'}}>{pending}</span> / <span style={{color: 'red'}}>{refused}</span></Card.Header>
      </Card.Content>
      <Card.Description textAlign='center'>
        {accepted} keys accepted, {pending} keys refused and {refused} keys refused.
      </Card.Description>
    </Card>
  )
}

MinionKeys.propTypes = {
  accepted: PropTypes.number,
  pending: PropTypes.number,
  refused: PropTypes.number
}
MinionKeys.defaultProps = {
  accepted: 0,
  pending: 0,
  refused: 0
}

export default MinionKeys



// WEBPACK FOOTER //
// ./src/components/dashboard/MinionKeys.js